import { render } from "./DripversityDvIcon.vue?vue&type=template&id=0e7f5dae&scoped=true"
const script = {}

import "./DripversityDvIcon.vue?vue&type=style&index=0&id=0e7f5dae&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7f5dae"]])

export default __exports__